import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { map } from 'rxjs';
import { AUTH_ROUTE_PATH } from '../models/auth-user.model';
import { AuthStateService } from '../services/auth-state.service';

export const authGuard: CanMatchFn = (_route, segments: UrlSegment[]) => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  return auth.isAuthenticatedOnceResolved().pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) return true;

      return router.createUrlTree([AUTH_ROUTE_PATH.LOGIN], {
        queryParams: { returnUrl: `/${segments.map((s) => s.path).join('/')}` },
      });
    }),
  );
};
